import { Expose, Type } from 'class-transformer';

export class MyActivityModel {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'date' })
  date: string;
  @Expose({ name: 'time' })
  time: string;
  @Expose({ name: 'type' })
  type: string;
  @Expose({ name: 'free_site_name' })
  free_site_name?: string;
}
